import { Button, Stack } from '@mui/material'
import { ReactNode } from 'react'
import ArrowLeftNewSvg from '~/@ui/_sharedSvgs/ui/ArrowLeftNew.svg?react'

type Props = {
  onClickBack?: () => void
  children?: ReactNode
  className?: string
}

export const SimplePageWrapper = ({
  onClickBack,
  children,
  className = '',
}: Props) => {
  return (
    <Stack
      className={`w-full max-w-[768px] h-dvh justify-self-center ${className}`}>
      <Stack className=" px-6 py-4">
        <Button className="w-16 h-11 bg-zGrey200" onClick={onClickBack}>
          <ArrowLeftNewSvg />
        </Button>
      </Stack>
      {children}
    </Stack>
  )
}
